import { DEVELOPER_ID, DEVELOPER_NAME } from 'shared/constants/developer';
import { createDeveloperGaProduct, createDeveloperProduct } from 'shared/utils/analytics';
import { type IDeveloperGaProduct } from 'shared/utils/analytics/createDeveloperGaProduct';
import { type IDeveloperProduct } from 'shared/utils/analytics/createDeveloperProduct';

import type { TPromoType } from '../types/promos';

export interface IPromoIdExtraObject {
  promo_type: TPromoType | null | undefined;
  promo_cian_mortgage?: string;
  promo_id: number;
  position: number;
}

export type TExtra =
  | {
      promoId?: number;
      promoCianMortgage?: string;
    }
  | {
      corpus_id?: number;
    }
  | {
      corpus_id?: number;
      room_num?: string;
    }
  | {
      bankId: number;
      bank_name: string;
    }
  | {
      promoId: string;
      position: number;
    }
  | {
      promoId: IPromoIdExtraObject[];
    }
  | {
      promoId: string[];
    }
  | {
      promotion_id: number;
    };

interface IProductData extends IDeveloperProduct, IDeveloperGaProduct {
  extra: TExtra;
  position: number;
}

export function getProductsData(extra: TExtra, position: number = 1): IProductData {
  return {
    ...createDeveloperProduct({ id: DEVELOPER_ID }),
    ...createDeveloperGaProduct(DEVELOPER_ID, DEVELOPER_NAME),
    extra,
    position,
  };
}
